import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M3.99408 13.5059C3.66864 13.1805 3.66864 12.6528 3.99408 12.3274L9.82741 6.49408C10.1528 6.16864 10.6805 6.16864 11.0059 6.49408L16.8393 12.3274C17.1647 12.6528 17.1647 13.1805 16.8393 13.5059C16.5138 13.8314 15.9862 13.8314 15.6607 13.5059L10.4167 8.26184L5.17259 13.5059C4.84715 13.8314 4.31951 13.8314 3.99408 13.5059Z",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2
  ]))
}